import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from './../../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class TagJoinService
{
	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	addTagJoin(data): Observable<ApiResponse>
	{
		// addTagJoin allows ONE tag of same tagType for each ownerLeadProfile (ie project #5)
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/tag-joins/save-one`, data);
	}

	getTagByType(tagType: any, tagSource: any, tagSourceId: any ): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${ environment.apiUrl }/tag-joins/tag-by-type/${ tagType }/${ tagSource }/${ tagSourceId }`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findTagsWith(queryString: string, source: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/tag-joins/find-with?query=${queryString}&source=${source}`).pipe(retry({ count: 2, delay: 1500 }));
	}
  findTagsWithType(queryString: string, source: number, type: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/tag-joins/find-with-type?query=${queryString}&source=${source}&tagtype=${type}`).pipe(retry({ count: 2, delay: 1500 }));
  }

	addTagJoins(data): Observable<ApiResponse>
	{
		// addTagJoins allows multiple tags of same tagType for each ownerLeadProfile (ie tags #4)
		console.log('posting... ' + JSON.stringify(data));
		return this.http.post<ApiResponse>(`${ environment.apiUrl }/tag-joins`, data);
	}

	deleteTagJoin(data): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(data));
		let options = {
			body: data
		 }
		return this.http.delete<ApiResponse>(`${ environment.apiUrl }/tag-joins`, options);
	}

	deleteMultipleTagJoin(data): Observable<ApiResponse>
	{
		console.log('posting... ' + JSON.stringify(data));
		let options = {
			body: data
		 }
		return this.http.delete<ApiResponse>(`${ environment.apiUrl }/tag-joins-ids`, options);
	}
}
